const DojoReportResultStatus = Object.freeze({
    COMPLETED: 'COMPLETED',
    TIMED_OUT: 'TIMED_OUT',
    UNSUCCESSFUL: 'UNSUCCESSFUL',
});

module.exports = DojoReportResultStatus;
